module.exports = __webpack_public_path__ + "static/paidy_logo-b6d6cd39e938f7ca7a0e024df9e78474.png";